import React from "react";
import { useHistory } from "react-router-dom";

import { Typography, Avatar, Card, Grid } from "@material-ui/core";

import { normaliseMEPScore, ScoreView } from "../Utilities/ScoreView";
import { MEP } from "../Home/MEP";

export const MEPHighscoreCard: React.FC<{ mep: MEP }> = ({ mep }) => {
  const history = useHistory();

  return (
    <Grid item xs={6} md={4} lg={3} container>
      <Card
        onClick={() => {
          history.push(`/mep/${mep.objectID}`);
        }}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "10px",
        }}
      >
        <Avatar
          alt={mep.name}
          src={mep.image}
          style={{
            height: "150px",
            width: "150px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        />
        <Typography align="center">{mep.name}</Typography>
        <div style={{ width: "100%" }}>
          <ScoreView
            scoreNormalised={normaliseMEPScore(mep.score)}
            score={mep.score}
          />
        </div>
      </Card>
    </Grid>
  );
};
